// extracted by mini-css-extract-plugin
export default {"wrapper":"EditorNavigation_wrapper__XarUj"};